<template>
    <div>
        <anexo v-if="deveEnviarDocumentosSolicitados && !deveMostrarMensagemComprasExclusivas"
               :anexos.sync="fornecedor.documentosSolicitados"
               @adicionarAnexo="adicionarAnexoEnvioProposta"
               @downloadAnexo="tratarEventDownloadAnexo"
               @removerDocumento="tratarEventoRemoverDocumento"/>

        <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile mb-2">
            <h3 class="card-dados__titulo mb-0">Proposta Inicial</h3>

            <div v-if="deveMostrarMensagemComprasExclusivas" class="container-legenda-compras-exclusivas">
                <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                <p class="legenda-compras-exclusivas">
                    A compra é destinada exclusivamente a empresas ME/EPP/MEI. <br/>
                    Por favor, revise cuidadosamente as informações fornecidas, pois é necessário atender a esse critério para prosseguir.
                </p>

            </div>

            <div class="container-legenda-busca my-3">

                <p v-if="porteExclusivoObrigatorio"
                   class="legenda">
                    Possui item exclusivo para empresa do porte {{formatarLista(portes) | azConcat}}
                </p>

                <v-text-field
                        class="proposta-input-busca"
                        @input="atualizarTermoBusca"
                        append-icon="search"
                        label="Busque pela descrição"
                        single-line
                        hide-details/>
            </div>

            <div class="alinhar-info mt-2 mb-2 justify-space-between acao-expandir-recolher" v-if="itensELotesDaProposta.lotes.length > 0">
                <h3 id="tituloLote" class="titulo mb-0" >Listagem</h3>

                <div v-if="itensELotesDaProposta.lotes.length > 1" class="text-xs-right">
                    <v-btn v-if="ultimoEstadoPaineis === 'recolhido'" flat @click="expandirTodos"
                           class="botao-simples mr-3">
                        <v-icon left size="15">fas fa-chevron-down</v-icon>
                        Expandir Todos
                    </v-btn>
                    <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
                        <v-icon left size="15">fas fa-chevron-up</v-icon>
                        Recolher Todos
                    </v-btn>
                </div>
            </div>

            <v-expansion-panel v-if="itensELotesDaProposta.lotes.length > 0"
                               v-model="paineis" expand
                               class="painel-itens">
                <v-expansion-panel-content v-for="lote in itensELotesDaProposta.lotes" :key="lote.id"
                                           class="painel-itens__linha borda-linha cabecalho-painel">
                    <template v-slot:header>
                        <p>
                            <strong>{{ lote.descricao }}</strong>
                            <v-tooltip top v-if="lote.motivo">
                                <a slot="activator">
                                    <i class="fas fa-comment" aria-hidden="true"/>
                                </a>
                                {{ lote.motivo }}
                            </v-tooltip>
                        </p>
                        <lote-maior-desconto class="area-proposta-maior-desconto" v-if="mustMountLoteMaiorDesconto"
                            :lote="lote"
                            :casasDecimais="itensELotesDaProposta.casasDecimais"
                            :prefix="prefix"
                            :suffix="suffix"
                            :propostaEnviada="propostaSituacaoEnviada"
                            :aceitaValorZero="aceitaValorZero"
                            @salvarLote="tratarEventoSalvarLote"
                        />
                        <div class="painel-itens__info">
                            <p>Exclusivo {{formatarLista(portes) | azConcat}}:</p>
                            <p class="ml-2">{{ lote.porteExclusivo ? 'Sim' : 'Não' }}</p>
                        </div>
                    </template>

                    <linha-fornecimento-msg-alert v-if="!lote.todosItensDoLotePossuiLinhaFornecimento" :itens="lote.itens"/>

                    <proposta-tabela-item v-model="lote.itens"
                                          tipo="LOTE"
                                          :possuiValorReferencia="resumoProposta.possuiValorReferencia"
                                          :exibirValorDeReferencia="resumoProposta.exibeValorReferencia"
                                          :propostaEnviada="propostaEnviada"
                                          :exibirExclusivo="false"
                                          :fornecedorPossuiPorte="itensELotesDaProposta.possuiPorte"
                                          :loteExclusivo="lote.porteExclusivo"
                                          :preenchimentoObrigatorio="setarPreenchimentoObrigatorio(lote.itens)"
                                          :casasDecimais="itensELotesDaProposta.casasDecimais"
                                          :casasDecimaisQuantidade="resumoProposta.casasDecimaisQuantidade"
                                          :origemCompraDireta="itensELotesDaProposta.origemCompraDireta"
                                          :termoBusca="termoBuscaLote"
                                          :exibirPaginacao="exibirPaginacaoEBusca(lote.itens)"
                                          :criterioJulgamento="resumoProposta.criterioJulgamento"
                                          :prefixoValor="resumoProposta.prefixoValor"
                                          :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                          :placeholderInput="resumoProposta.placeholderInputLances"
                                          @salvarItem="tratarEventoDeSalvarItemDaProposta"
                                          class="lista-lote-item"/>

                    <div class="total total-mobile">
                        <span v-if="!isCriterioJulgamentoMaiorDesconto">
                            <strong>Total Unitário:</strong>
                            {{ lote.totalUnitario | cdCurrency(prefix, itensELotesDaProposta.casasDecimais)}}{{suffix}} |
                        </span>
                        <span>
                            <strong> {{isCriterioJulgamentoMaiorDesconto ? 'Desconto:' : 'Total:'}}</strong>
                            {{ lote.totalGeral | cdCurrency(prefix, itensELotesDaProposta.casasDecimais)}}{{suffix}}
                        </span>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <div class="total total-listagem" v-if="deveMostrarTotalGeralLotes">
                <p>
                    <strong>Total Geral: </strong> {{ totalLotes | cdCurrency(prefix, itensELotesDaProposta.casasDecimais)}}{{suffix}}
                </p>
            </div>

            <h3 id="tituloItem" v-if="itensELotesDaProposta.itens.length > 0" class="titulo mt-2 mb-0 titulo-listagem">Listagem</h3>

            <linha-fornecimento-msg-alert v-if="itensELotesDaProposta.fornecedorSemLinhaFornecimentoEmItemAvulso" :itens="itensELotesDaProposta.itens"/>

            <proposta-tabela-item v-if="itensELotesDaProposta.itens.length > 0"
                                  v-model="itensELotesDaProposta.itens"
                                  tipo="ITEM"
                                  :possuiValorReferencia="resumoProposta.possuiValorReferencia"
                                  :exibirValorDeReferencia="resumoProposta.exibeValorReferencia"
                                  :propostaEnviada="propostaEnviada"
                                  :exibirExclusivo="true"
                                  :fornecedorPossuiPorte="itensELotesDaProposta.possuiPorte"
                                  :casasDecimais="itensELotesDaProposta.casasDecimais"
                                  :casasDecimaisQuantidade="resumoProposta.casasDecimaisQuantidade"
                                  :origemCompraDireta="itensELotesDaProposta.origemCompraDireta"
                                  :termoBusca="termoBuscaItem"
                                  :exibirPaginacao="exibirPaginacaoEBusca(itensELotesDaProposta.itens)"
                                  :criterioJulgamento="resumoProposta.criterioJulgamento"
                                  :prefixoValor="resumoProposta.prefixoValor"
                                  :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                  :placeholderInput="resumoProposta.placeholderInputLances"
                                  @salvarItem="tratarEventoDeSalvarItemDaProposta"/>

            <div class="total total-item-mobile" v-if="deveMostrarTotalGeralItens">
                <p>
                    <strong>Total Geral: </strong> {{ totalItens | cdCurrency(prefix, itensELotesDaProposta.casasDecimais)}}{{suffix}}
                </p>
            </div>

            <h4 class="texto-total" v-if="!isCriterioJulgamentoMaiorDesconto">
                <strong>Total Proposta: </strong> {{ totalProposta | cdCurrency(prefix, itensELotesDaProposta.casasDecimais)}}{{suffix}}
            </h4>
        </v-flex>

        <div class="az-actions-form acao-botao">
            <botao-voltar @voltar="irParaTermos" id="botao-voltar-termo"/>
            <botao-cancelar-proposta-com-dipsuta v-if="exibirBotaoCancelarProposta" id="botao-cancelar-envio-com-disputa"
                                                 :style="exibirBotaoEnviarProposta? 'margin-right: -200px' : ''"
                                                 @click="mostrarDialogoCancelarEnvioProposta = true" />
            <botao-enviar-proposta v-if="exibirBotaoEnviarProposta" :tipoCompraDireta="resumoProposta.tipo"
                                   @click="enviarProposta"/>
            <botao-avancar v-else @avancar="irParaProximaPagina"/>
        </div>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoEnviarProposta"
                              id="dialogo-confirmacao-cancelar-proposta"
                              titulo="Deseja realmente enviar a proposta?"
                              :textoPrimario=textoPrimario
                              :textoSecundario=textoSecundario
                              botaoRecusar="Cancelar"
                              botaoConfirmar="Enviar"
                              @confirmado="salvarProposta(true)"
                              @recusado="mostrarDialogoEnviarProposta = false"/>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoCancelarEnvioProposta"
                              id="dialogo-confirmacao-cancelar-proposta"
                              titulo="Cancelar Envio de Proposta"
                              textoPrimario="Deseja realmente cancelar o envio de proposta?"
                              :textoSecundario="null"
                              botaoRecusar="Não"
                              botaoConfirmar="Confirmar"
                              @confirmado="cancelarEnvioProposta"
                              @recusado="mostrarDialogoCancelarEnvioProposta = false"/>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoDocumentoCredenciamento"
                              id="dialogo-confirmacao-cancelar-proposta"
                              titulo="Envio de proposta"
                              textoPrimario="⚠️ Atenção !!!"
                              textoSecundario="Identificamos que alguns documentos não foram anexados. Certifique-se das exigências de documentação do processo."
                              botaoRecusar="Enviar mesmo assim"
                              botaoConfirmar="Voltar para anexar"
                              @confirmado="mostrarDialogoDocumentoCredenciamento = false"
                              @recusado="salvarProposta(true)"/>

        <alert :exibir.sync="exibirErroAlertaEmpate"
               :mensagem="mensagemErroAlertaEmpate"
               :excecoes="itensEmpatados"
               :link="linkMensagemErroEmpate"
               :isAlertaAmarelo="alertaAmarelo"
               @fechar="exibirErroAlertaEmpate = false"/>

        <modal-confirmacao-valores :exibirModal.sync="exibirAlertaValorInesperado"
                                   :itens="itensLotesValorInesperado"
                                   @cancelar="ocultarConfirmacaoValores"
                                   @confirmar="confirmarValores"/>

        <local-loading/>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {
    actionTypes,
    situacoesItensELotes,
    mutationTypes,
    keysDomainException,
    criteriosJulgamento
} from '@/core/constants'
import PropostaTabelaItem from '@/views/pages/fornecedor/etapas-participacao/proposta/PropostaTabelaItem'
import _ from 'lodash'
import BotaoCancelarPropostaComDipsuta from '../../../../components/BotaoCancelarPropostaComDisputa'
import BotaoEnviarProposta from '../../../../components/BotaoEnviarProposta'
import ModalConfirmacaoValores from '../../../../components/ModalConfirmacaoValores'
import Anexo from './anexo/Anexo'
import LoteMaiorDesconto from './lote-maior-desconto/LoteMaiorDesconto'
import LinhaFornecimentoMsgAlert from '@/views/pages/fornecedor/etapas-participacao/proposta/LinhaFornecimentoMsgAlert.vue'
import MensagemConfirmacao from '@/views/components/MensagemConfirmacao.vue'

export default {
    name: 'Proposta',
    components: {
        MensagemConfirmacao,
        ModalConfirmacaoValores,
        BotaoEnviarProposta,
        BotaoCancelarPropostaComDipsuta,
        PropostaTabelaItem,
        Anexo,
        LoteMaiorDesconto,
        LinhaFornecimentoMsgAlert
    },
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            keysDomainException,
            mensagemErroAlertaEmpate: '',
            exibirErroAlertaEmpate: false,
            alertaAmarelo: false,
            compraDiretaId: null,
            propostaId: null,
            paineis: [],
            ultimoEstadoPaineis: 'recolhido',
            totalmenteRecolhido: true,
            totalmenteExpandido: false,
            situacoesItensELotes,
            mostrarDialogoEnviarProposta: false,
            termoBuscaItem: '',
            termoBuscaLote: '',
            itensEmpatados: [],
            ItensLotesEmSalvamento: 0,
            mostrarDialogoCancelarEnvioProposta: false,
            linkMensagemErroEmpate: null,
            exibirAlertaValorInesperado: false,
            itensLotesValorInesperado: [],
            mostrarDialogoDocumentoCredenciamento: false,
            isPropostaMounted: false
        }
    },
    computed: {
        ...mapState(['resumoProposta', 'parametros', 'itensELotesDaProposta', 'compraDireta', 'loki', 'fornecedor']),
        propostaEnviada() {
            if (this.resumoProposta.tipo === 'SEM_DISPUTA' && this.resumoProposta.situacaoProposta === 'ENVIADA') {
                return true
            } else if (this.resumoProposta.tipo === 'SEM_DISPUTA' && this.resumoProposta.situacaoProposta === 'EM_ELABORACAO') {
                return false
            } else if (this.resumoProposta.tipo === 'SEM_DISPUTA' && this.resumoProposta.situacaoProposta === 'CANCELADA') {
                return true
            } else if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.possuiLoteOuItemEmElaboracao() && !this.resumoProposta.tempoRandomico) {
                return false
            }  else if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.possuiLoteOuItemEmElaboracao() && this.resumoProposta.tempoRandomico) {
                return true
            } else {
                return this.resumoProposta.tipo === 'COM_DISPUTA' && !this.possuiLoteOuItemEmElaboracao()
            }
        },
        exibirBotaoEnviarProposta() {
            if (this.exibirFimEnvioPropostasELances) {
                return this.resumoProposta.estaNaEtapaPropostas && this.possuiLoteOuItemEmElaboracao() && !this.deveMostrarMensagemComprasExclusivas
            }
            return !this.propostaEnviada && !this.deveMostrarMensagemComprasExclusivas
        },
        exibirBotaoCancelarProposta(){
            if(!this.exibirFimEnvioPropostasELances)
                return false

            return this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.estaNaEtapaPropostas && this.resumoProposta.situacaoProposta === 'ENVIADA'
        },
        totalItens() {
            let total = 0
            this.itensELotesDaProposta.itens.forEach(item => {
                if (item.valorUnitario >= 0) {
                    total += item.total
                }
            })
            return total
        },
        totalLotes() {
            let total = 0
            this.itensELotesDaProposta.lotes.forEach(lote => {
                total += lote.totalGeral
            })
            return total
        },
        totalProposta() {
            return this.totalLotes + this.totalItens
        },
        textoPrimario() {
            const exibirFimEnvioPropostasELances = this.exibirFimEnvioPropostasELances
            if (this.resumoProposta.tipo === 'COM_DISPUTA' && !exibirFimEnvioPropostasELances) {
                return 'Após o envio você será redirecionado automaticamente para tela de lances.'
            } else if(this.resumoProposta.tipo === 'COM_DISPUTA' && exibirFimEnvioPropostasELances) {
                return 'Após a confirmação somente os itens que não foram enviados poderão ser editados.'
            } else {
                return 'Após o envio você será redirecionado automaticamente para tela de protocolo.'
            }
        },
        textoSecundario() {
            const exibirFimEnvioPropostasELances = this.exibirFimEnvioPropostasELances
            if (this.resumoProposta.tipo === 'COM_DISPUTA' && !exibirFimEnvioPropostasELances) {
                return 'E somente os itens que não foram enviados poderão ser editados.'
            } else if(this.resumoProposta.tipo === 'COM_DISPUTA' && exibirFimEnvioPropostasELances){
                return 'Deseja continuar?'
            } else {
                return ''
            }
        },
        exibirFimEnvioPropostasELances() {
            return this.exibirFimPropostasELances(this.compraDireta.amparoLegal)
        },
        fourbillingAtivo(){
            if(this.parametros.propriedadesCompraDiretas.sistemaVerificacaoPlano === 'pagamentos')
                return this.parametros.propriedadesCompraDiretas.integration.sistemaDePagamentos === '4billing'
            return false
        },
        uploadedFiles(){
            return this.loki.uploadedFiles
        },
        deveEnviarDocumentosSolicitados(){
            let documentosSolicitados = []

            if(this.fornecedor.documentosSolicitados)
                documentosSolicitados = this.fornecedor.documentosSolicitados

            return documentosSolicitados.length > 0
        },
        prefix(){
            return this.resumoProposta.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.resumoProposta.prefixoValor === '%' ? '% ' : ''
        },
        isCriterioJulgamentoMaiorDesconto(){
            return this.compraDireta.criterioJulgamento === criteriosJulgamento.MAIOR_DESCONTO.valor
        },
        deveMostrarTotalGeralItens() {
            return !this.isCriterioJulgamentoMaiorDesconto &&
                (this.itensELotesDaProposta.itens.length > 1 &&
                    this.itensELotesDaProposta.lotes.length > 0)
        },
        deveMostrarTotalGeralLotes(){
            return !this.isCriterioJulgamentoMaiorDesconto &&
                (this.itensELotesDaProposta.lotes.length > 1 &&
                    this.itensELotesDaProposta.itens.length > 0)
        },
        aceitaValorZero() {
            return this.parametros.propriedadesCompraDiretas.fornecedor.proposta.aceitarValorZero
        },
        propostaSituacaoEnviada(){
            return this.resumoProposta.propostaEnviada || this.resumoProposta.situacaoProposta === 'ENVIADA'
        },
        mustMountLoteMaiorDesconto(){
            return this.isPropostaMounted && this.isCriterioJulgamentoMaiorDesconto
        },
        porteExclusivoObrigatorio(){
            return this.parametros.propriedadesCompraDiretas.porteExclusivoObrigatorioProposta
        },
        ehCompraInteramenteExclusiva(){
            return this.itensELotesDaProposta.itens
                .every(item => item.porteExclusivo === true) &&
                this.itensELotesDaProposta.lotes
                    .every(lote => lote.porteExclusivo === true)
        },
        deveMostrarMensagemComprasExclusivas(){
            return this.porteExclusivoObrigatorio &&
                this.ehCompraInteramenteExclusiva &&
                !this.itensELotesDaProposta.possuiPorte
        }

    },
    async mounted() {
        try {
            this.setCompraDiretaIdEPropostaId()
            await this.buscarDetalhesDaCompraDireta()
            await this.buscarResumoProposta()
            await this.buscarLotesEItens()
            await this.desabilitarLoadingGlobal()
            await this.buscarDocumentosSolicitadosEnvioProposta()
            this.isPropostaMounted = true
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarDetalhesDaCompraDireta() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_DETALHES_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        limparPropostasDeLotesExclusivos() {
            if (this.itensELotesDaProposta.possuiPorte) return

            const lotesParaLimparValorProposta = this.buscaLotesExclusivosComPropostaPreenchida()
            lotesParaLimparValorProposta.forEach((lote) => {
                this.limparPropostasDeItensExclusivos(lote.itens)
            })
        },
        limparPropostasDeItensExclusivos(
            itensParaLimparValorProposta = this.buscaItensExclusivosComPropostaPreenchida()
        ) {

            if (this.itensELotesDaProposta.possuiPorte) return

            itensParaLimparValorProposta.forEach((item) => {
                this.limparProposta(item)
            })
        },
        limparProposta(item) {
            item.valorUnitario = null
            item.marca = null
            item.modelo = null
            this.tratarEventoDeSalvarItemDaProposta(item)
        },
        buscaItensExclusivosComPropostaPreenchida() {
            return this.itensELotesDaProposta.itens.filter((item) => {
                return item.porteExclusivo && item.valorUnitario
            })
        },
        buscaLotesExclusivosComPropostaPreenchida() {
            return this.itensELotesDaProposta.lotes.filter((lote) => {
                return lote.porteExclusivo && lote.totalGeral
            })
        },
        async buscarResumoProposta() {
            const infoObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA, infoObj)
        },
        async buscarLotesEItens() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_ITENS_E_LOTES_DA_PROPOSTA, this.compraDiretaId)
            this.expandirTodos()
        },
        async tratarEventoDeSalvarItemDaProposta(itemProposta) {
            this.ItensLotesEmSalvamento++
            itemProposta.compraDiretaId = this.compraDiretaId
            itemProposta.propostaId = this.propostaId
            this.$store.dispatch(actionTypes.FORNECEDOR.SALVAR_ITEM_DA_PROPOSTA, itemProposta)
                .finally(() => {
                    this.ItensLotesEmSalvamento--
                })
        },
        async enviarProposta() {
            await this.verificarCamposObrigatorios()
            this.verificarValorTotalProposta()
            this.verificarSePossuiLoteOuItemPreenchido()
            if(this.deveEnviarDocumentosSolicitados)
                this.exibirDailogDocumentoCredenciamento()
            else
                this.exibirDialogoEnvioDeProposta()
        },
        async cancelarEnvioProposta(){
            this.mostrarDialogoCancelarEnvioProposta = false
            const infoObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId,
                numeroProtocolo: this.resumoProposta.numeroProtocolo
            }
            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.CANCELAR_ENVIO_DA_PROPOSTA_COM_DISPUTA, infoObj)
            this.propostaId = resultado.propostaId
            this.mostrarNotificacaoSucesso('Sua proposta foi cancelada com sucesso.')
            this.atualizarRota()
            await this.buscarResumoProposta()
            await this.buscarLotesEItens()
        },
        atualizarRota() {
            this.$router.push({
                name: 'PropostaDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        exibirDialogoEnvioDeProposta() {
            this.mostrarDialogoDocumentoCredenciamento = false
            this.mostrarDialogoEnviarProposta = true
        },
        verificarValorTotalProposta(){
            if(this.totalItens >= 10000000000){
                throw new Error('O valor total dos itens não pode ser igual ou superior a 10 Bilhões.')
            }
            if(this.totalLotes >= 10000000000){
                throw new Error('O valor total dos lotes não pode ser igual ou superior a 10 Bilhões.')
            }
            if(this.totalProposta >= 10000000000){
                throw new Error('O valor total da proposta não pode ser igual ou superior superior a 10 Bilhões.')
            }
        },
        exibirLoadingLocal(exibir) {
            this.$store.commit(mutationTypes.SET_LOADING_LOCAL_EXIBIR, Boolean(exibir))
        },
        async esperarSalvamentoAutomaticoTerminar() {
            while (this.ItensLotesEmSalvamento > 0) { await this.aguardarUmSegundo() }
        },
        aguardarUmSegundo() {
            return new Promise(resolve => setTimeout(resolve, 1000))
        },
        async confirmarValores(){
            this.exibirAlertaValorInesperado = false
            this.itensLotesValorInesperado=[]
            await this.salvarProposta(false)
        },
        async salvarProposta(validarMargem) {
            this.mostrarDialogoEnviarProposta = false
            this.mostrarDialogoDocumentoCredenciamento = false
            this.exibirLoadingLocal(true)
            await this.esperarSalvamentoAutomaticoTerminar()

            const dadosObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId,
                validarMargem: validarMargem
            }

            try {
                await this.$store.dispatch(actionTypes.FORNECEDOR.ENVIAR_PROPOSTA, dadosObj)
                this.mostrarNotificacaoSucesso('Proposta enviada com sucesso')
                await this.buscarResumoProposta()
                await this.buscarLotesEItens()
                if(this.resumoProposta.tipo === 'SEM_DISPUTA'){
                    await this.irParaProtocolo()
                }else if(!this.exibirFimEnvioPropostasELances){
                    this.irParaProximaPagina()
                }
            } catch (err) {
                if(err.response && err.response.data && err.response.data.key === this.keysDomainException.VALOR_FORA_MARGEM_ESPERADA){
                    this.exibirAlertaValorInesperado = true
                    let itensOuLotes = err.response.data.detail.itensOuLotes
                    itensOuLotes.forEach(item => item.valorDigitado=null)
                    this.itensLotesValorInesperado = itensOuLotes
                    return
                }

                if(this.fourbillingAtivo && err.message.includes('plano')){
                    this.mensagemErroAlertaEmpate = err.message
                    this.itensEmpatados = null
                    this.linkMensagemErroEmpate = {
                        texto: 'Visualizar Planos',
                        url: this.parametros.propriedadesCompraDiretas.urlVisualizarPlanos,
                        redirecionar: false
                    }
                    this.alertaAmarelo = true
                    this.exibirErroAlertaEmpate = true
                }else {
                    if ((err.name !== 'ApiErrorValidations' || !('errorMessages' in err.response.data))) throw err

                    this.linkMensagemErroEmpate = null
                    this.mensagemErroAlertaEmpate = err.response.data.errorMessages[0].message
                    this.itensEmpatados = err.response.data.errorMessages[0].args
                    this.alertaAmarelo = false
                    this.exibirErroAlertaEmpate = true
                }
            } finally {
                this.exibirLoadingLocal(false)
            }
        },
        async verificarCamposObrigatorios() {
            const estaValidado = await this.$validator._base.validateAll()
            if (!estaValidado) {
                throw new Error('Preencha todos os campos obrigatórios.')
            }
        },
        verificarSePossuiLoteOuItemPreenchido() {
            const algumItemPreenchido = this.itensELotesDaProposta.itens.some(item => (item.valorUnitario !== null && item.valorUnitario >= 0 && item.situacao === 'EM_ELABORACAO'))

            const algumLotePreenchido = this.itensELotesDaProposta.lotes.some(lote => {
                return lote.itens.some(item => (item.valorUnitario !== null && item.valorUnitario >= 0 && item.situacao === 'EM_ELABORACAO'))
            })

            if (!algumItemPreenchido && this.itensELotesDaProposta.lotes.length === 0) {
                throw new Error('Preencha pelo menos um item para enviar a proposta.')
            } else if (!algumLotePreenchido && this.itensELotesDaProposta.itens.length === 0) {
                throw new Error('Preencha pelo menos um grupo de itens para enviar a proposta.')
            } else if (!algumItemPreenchido && !algumLotePreenchido) {
                throw new Error('Preencha pelo menos um item para enviar a proposta.')
            }
        },
        possuiLoteOuItemEmElaboracao() {
            const possuiItemEmElaboracao = this.itensELotesDaProposta.itens.some(item => {
                return item.situacao === 'EM_ELABORACAO'
            })

            const possuiLoteEmElaboracao = this.itensELotesDaProposta.lotes.some(lote => {
                return lote.situacao === 'EM_ELABORACAO'
            })

            return possuiItemEmElaboracao || possuiLoteEmElaboracao
        },
        irParaProximaPagina() {
            if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.estaNaEtapaLances && this.resumoProposta.situacaoProposta === 'ENVIADA') {
                this.irParaLances()
            } else if (this.resumoProposta.tipo === 'COM_DISPUTA') {
                this.irParaDetalhesDaCompraDireta()
            } else if(this.resumoProposta.situacaoProposta === 'ENVIADA') {
                this.irParaProtocolo()
            }else{
                this.irParaTermos()
            }
        },
        irParaDetalhesDaCompraDireta() {
            this.$router.push({ name: 'DetalhesCompraDireta' })
        },
        expandirTodos() {
            const todosPaineisAbertos = this.itensELotesDaProposta.lotes.map(() => {
                return true
            })
            this.paineis = todosPaineisAbertos
            this.totalmenteExpandido = true
            this.verificarUltimoEstado()
        },
        recolherTodos() {
            const todosPaineisFechados = this.itensELotesDaProposta.lotes.map(() => {
                return false
            })
            this.paineis = todosPaineisFechados
            this.totalmenteExpandido = false
        },
        irParaTermos() {
            this.$router.push({
                name: 'TermoDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        irParaLances() {
            this.$router.push({
                name: 'LanceDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        irParaProtocolo() {
            this.$router.push({
                name: 'ProtocoloDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        setCompraDiretaIdEPropostaId() {
            this.compraDiretaId = this.$route.params.id
            this.propostaId = this.$route.params.propostaId
        },
        verificarUltimoEstado() {
            if (this.totalmenteExpandido) {
                this.ultimoEstadoPaineis = 'expandido'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoPaineis = 'recolhido'
            }
        },
        setarPreenchimentoObrigatorio(itens) {
            return itens.some(item => (item.valorUnitario !== null || (item.marca ? item.marca.trim() !== '' :false)))
        },
        exibirPaginacaoEBusca(listaItemOuLote) {
            return listaItemOuLote.length > 10
        },
        ocultarConfirmacaoValores(){
            this.exibirAlertaValorInesperado=false
            this.itensLotesValorInesperado=[]
        },
        atualizarTermoBusca: _.debounce(function (termo) {
            this.termoBuscaItem = this.termoBuscaLote = termo
        }, 400),
        async buscarDocumentosSolicitadosEnvioProposta() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA,
                this.compraDiretaId)
        },
        async adicionarAnexoEnvioProposta(arquivo) {
            const anexoObj = {
                compraDiretaId: this.compraDiretaId,
                arquivo
            }
           
            if (!arquivo.documentoSolicitadoId) {
                this.mostrarNotificacaoErro('Ausência do Id do documento solicitado.')
                return
            }
            
            try {
                await this.$store.dispatch(actionTypes.FORNECEDOR.ADICIONAR_ANEXO_DOCUMENTO_SOLICITADO_DA_PROPOSTA, anexoObj)
                this.mostrarNotificacaoSucesso('Arquivo anexado com sucesso.')
            } catch (e) {
                this.mostrarNotificacaoErro('Erro ao adicionar anexo ao documentos solicitado da proposta')
            }
            this.buscarDocumentosSolicitadosEnvioProposta()
        },
        async tratarEventoRemoverDocumento(documento) {
            const objetoParaRemover ={
                compraDiretaId: this.compraDiretaId,
                documentoApresentadoId: documento.id
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.REMOVER_DOCUMENTO_APRESENTADO, objetoParaRemover)
            this.mostrarNotificacaoSucesso('Arquivo removido com sucesso.')
            this.buscarDocumentosSolicitadosEnvioProposta()
        },
        exibirDailogDocumentoCredenciamento(){
            const documentosSolicitados = this.fornecedor.documentosSolicitados
            const todosDocumentosAnexados = documentosSolicitados.every(documento => documento.id !== null)

            if(!todosDocumentosAnexados)
                this.mostrarDialogoDocumentoCredenciamento = true
            else
                this.exibirDialogoEnvioDeProposta()
        },
        async tratarEventoSalvarLote(lote){
            const data = {
                compraDiretaId: this.compraDireta.id,
                propostaId: this.resumoProposta.propostaId,
                loteId: lote.loteId,
                desconto: lote.totalUnitario
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.ATUALIZAR_LOTE_PROPOSTA_MAIOR_DESCONTO, data)
        },
        async tratarEventDownloadAnexo(documento){
            const info = {
                uri: documento.uri,
                nome: this.getNome(documento)
            }

            await this.$store.dispatch(actionTypes.DOWNLOAD_ANEXO, info)
        },
        getNome(documento){
            if(documento.descricao)
                return documento.descricao.replaceAll(' ', '_')
            return documento.uri.substring(documento.uri.lastIndexOf('/') + 1)
        }
    },
    watch: {
        paineis() {
            let todosExpandidos = true
            let todosRecolhidos = true

            for (let posicao of this.paineis) {
                if (!posicao) {
                    todosExpandidos = false
                } else {
                    todosRecolhidos = false
                }
            }

            this.totalmenteExpandido = todosExpandidos
            this.totalmenteRecolhido = todosRecolhidos
            this.verificarUltimoEstado()
        }
    }
}
</script>

<style lang="stylus">
    .proposta-input-busca .v-input__control .v-input__slot .v-text-field__slot .v-label
        font-size 13px !important
</style>

<style scoped lang="stylus">

    .alinhar-info
        display flex
        align-items center

    .titulo
        font-size 1.1rem
        color #777
        margin-left 16px
        clear both

    .container-legenda-busca
        display flex
        justify-items auto

    .legenda
        font-size 13px
        color #777
        margin 8px 16px
        width 40%

    .proposta-input-busca
        margin 0 16px
        padding-top 0
        width 60%
        font-size 13px

    .texto-total
        color #777
        text-align right
        padding 0 16px 16px
        font-weight normal
        clear both

    .painel-itens__info
        margin-right 20px

    .container-legenda-compras-exclusivas
        font-size 14px
        color #664d03
        margin 8px 16px
        padding 5px 18px
        background-color #fff3cd !important
        border 1px solid #fff3cd !important
        border-radius 3px
        display flex
        flex-direction row
        align-items center

        p.legenda-compras-exclusivas
            margin 0 20px
            color #664d03 !important
        i
            color #664d03 !color
            font-size 25px

    @media (max-width 720px)
        .az-actions-form
            flex-direction column

        .botao-enviar
            flex-direction column

        .botao-principal
            margin 20px 0

        .botao-default
            order 1
            margin 20px 0 0

        .texto-alerta
            text-align center
            margin-right 0

        .texto-total
            padding 0 0 16px

        .total-item-mobile
            margin 16px 0

        .titulo-listagem
            display none

        .painel-itens__info
            margin-right 10px

    .acao-botao
        justify-content space-between

</style>
